
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function Portfolio() {
  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-purple-600 to-blue-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold text-white mb-6">
            Our Success Stories
          </h1>
          <p className="text-xl text-purple-100 max-w-3xl mx-auto">
            Explore our portfolio of successful marketing campaigns and see how we've helped businesses achieve extraordinary growth and measurable results.
          </p>
        </div>
      </section>

      {/* Featured Case Studies */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Featured Case Studies
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Real results from real clients. See how our strategic marketing approach has transformed businesses across various industries.
            </p>
          </div>
          
          <div className="space-y-16">
            {/* Case Study 1 */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-semibold inline-block mb-4">
                  E-commerce Growth
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  TechStart Inc. - 300% Revenue Increase
                </h3>
                <p className="text-lg text-gray-600 mb-6">
                  Complete digital transformation for a tech startup, including brand redesign, SEO optimization, and targeted PPC campaigns that resulted in explosive growth.
                </p>
                <div className="grid grid-cols-3 gap-4 mb-6">
                  <div className="text-center">
                    <div className="text-2xl font-bold text-blue-600">300%</div>
                    <div className="text-sm text-gray-500">Revenue Growth</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-green-600">250%</div>
                    <div className="text-sm text-gray-500">Traffic Increase</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-purple-600">180%</div>
                    <div className="text-sm text-gray-500">Conversion Rate</div>
                  </div>
                </div>
                <Button href="/contact" variant="primary">
                  Learn More
                </Button>
              </div>
              <div>
                <img 
                  src="https://static.readdy.ai/image/d284d72deac738ef2474c9b45b1f2d97/2f66a1bd9a7e83315bf21db5a7039b57.jpeg"
                  alt="TechStart Inc. Case Study"
                  className="rounded-2xl shadow-lg object-cover w-full h-80"
                />
              </div>
            </div>

            {/* Case Study 2 */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="order-2 lg:order-1">
                <img 
                  src="https://public.readdy.ai/ai/img_res/82a582b0bd6262ed73bb9e7eac0d3bf0.jpg"
                  alt="Local Restaurant Chain Case Study"
                  className="rounded-2xl shadow-lg object-cover w-full h-80"
                />
              </div>
              <div className="order-1 lg:order-2">
                <div className="bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-semibold inline-block mb-4">
                  Local Business
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  Restaurant Chain - Brand Transformation
                </h3>
                <p className="text-lg text-gray-600 mb-6">
                  Complete brand overhaul and local SEO strategy for a restaurant chain, resulting in increased foot traffic and online orders across all locations.
                </p>
                <div className="grid grid-cols-3 gap-4 mb-6">
                  <div className="text-center">
                    <div className="text-2xl font-bold text-blue-600">150%</div>
                    <div className="text-sm text-gray-500">Foot Traffic</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-green-600">200%</div>
                    <div className="text-sm text-gray-500">Online Orders</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-purple-600">85%</div>
                    <div className="text-sm text-gray-500">Brand Recognition</div>
                  </div>
                </div>
                <Button href="/contact" variant="primary">
                  Learn More
                </Button>
              </div>
            </div>

            {/* Case Study 3 */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="bg-purple-100 text-purple-800 px-4 py-2 rounded-full text-sm font-semibold inline-block mb-4">
                  B2B Services
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  Professional Services - Lead Generation
                </h3>
                <p className="text-lg text-gray-600 mb-6">
                  Strategic content marketing and LinkedIn advertising campaign that transformed a B2B service provider's lead generation and client acquisition process.
                </p>
                <div className="grid grid-cols-3 gap-4 mb-6">
                  <div className="text-center">
                    <div className="text-2xl font-bold text-blue-600">400%</div>
                    <div className="text-sm text-gray-500">Lead Increase</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-green-600">60%</div>
                    <div className="text-sm text-gray-500">Conversion Rate</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-purple-600">250%</div>
                    <div className="text-sm text-gray-500">ROI Improvement</div>
                  </div>
                </div>
                <Button href="/contact" variant="primary">
                  Learn More
                </Button>
              </div>
              <div>
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20B2B%20marketing%20campaign%20results%2C%20business%20networking%20and%20lead%20generation%20graphics%2C%20corporate%20marketing%20success%20metrics%2C%20professional%20services%20marketing%20dashboard&width=600&height=400&seq=case-study-b2b&orientation=landscape"
                  alt="B2B Services Case Study"
                  className="rounded-2xl shadow-lg object-cover w-full h-80"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Portfolio Grid */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Recent Projects
            </h2>
            <p className="text-xl text-gray-600">
              A showcase of our latest work across different industries and marketing channels.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20fitness%20app%20mobile%20interface%20design%2C%20clean%20health%20and%20wellness%20application%2C%20professional%20fitness%20brand%20marketing%20materials%2C%20athletic%20lifestyle%20branding&width=400&height=250&seq=portfolio-fitness&orientation=landscape"
                alt="Fitness App Branding"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <div className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-semibold inline-block mb-3">
                  Mobile App
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  FitLife App Launch
                </h3>
                <p className="text-gray-600 mb-4">
                  Complete brand identity and launch campaign for a fitness tracking mobile application.
                </p>
                <div className="flex justify-between text-sm text-gray-500">
                  <span>Brand Design</span>
                  <span>App Marketing</span>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Luxury%20real%20estate%20marketing%20materials%2C%20elegant%20property%20branding%20design%2C%20high-end%20real%20estate%20website%20interface%2C%20premium%20property%20marketing%20campaign&width=400&height=250&seq=portfolio-realestate&orientation=landscape"
                alt="Real Estate Marketing"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-semibold inline-block mb-3">
                  Real Estate
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Luxury Properties Campaign
                </h3>
                <p className="text-gray-600 mb-4">
                  High-end marketing campaign for luxury real estate properties with targeted advertising.
                </p>
                <div className="flex justify-between text-sm text-gray-500">
                  <span>Digital Marketing</span>
                  <span>PPC Campaigns</span>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20healthcare%20clinic%20branding%2C%20medical%20practice%20marketing%20materials%2C%20clean%20healthcare%20website%20design%2C%20medical%20services%20digital%20marketing&width=400&height=250&seq=portfolio-healthcare&orientation=landscape"
                alt="Healthcare Branding"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <div className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-xs font-semibold inline-block mb-3">
                  Healthcare
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Medical Practice Rebrand
                </h3>
                <p className="text-gray-600 mb-4">
                  Complete rebranding and digital presence overhaul for a growing medical practice.
                </p>
                <div className="flex justify-between text-sm text-gray-500">
                  <span>Brand Strategy</span>
                  <span>Web Design</span>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20e-commerce%20fashion%20website%2C%20stylish%20online%20clothing%20store%20interface%2C%20fashion%20brand%20digital%20marketing%2C%20trendy%20retail%20website%20design&width=400&height=250&seq=portfolio-fashion&orientation=landscape"
                alt="Fashion E-commerce"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <div className="bg-pink-100 text-pink-800 px-3 py-1 rounded-full text-xs font-semibold inline-block mb-3">
                  Fashion
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Fashion Brand Launch
                </h3>
                <p className="text-gray-600 mb-4">
                  E-commerce platform development and social media marketing for emerging fashion brand.
                </p>
                <div className="flex justify-between text-sm text-gray-500">
                  <span>E-commerce</span>
                  <span>Social Media</span>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20financial%20services%20marketing%2C%20corporate%20finance%20website%20design%2C%20investment%20firm%20branding%20materials%2C%20financial%20advisor%20digital%20marketing&width=400&height=250&seq=portfolio-finance&orientation=landscape"
                alt="Financial Services"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <div className="bg-indigo-100 text-indigo-800 px-3 py-1 rounded-full text-xs font-semibold inline-block mb-3">
                  Finance
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Investment Firm Website
                </h3>
                <p className="text-gray-600 mb-4">
                  Professional website redesign and content strategy for financial advisory services.
                </p>
                <div className="flex justify-between text-sm text-gray-500">
                  <span>Web Development</span>
                  <span>Content Strategy</span>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20technology%20startup%20branding%2C%20innovative%20tech%20company%20marketing%20materials%2C%20software%20development%20firm%20website%2C%20tech%20startup%20digital%20marketing&width=400&height=250&seq=portfolio-tech&orientation=landscape"
                alt="Tech Startup"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <div className="bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-xs font-semibold inline-block mb-3">
                  Technology
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  SaaS Platform Marketing
                </h3>
                <p className="text-gray-600 mb-4">
                  Go-to-market strategy and lead generation campaign for B2B SaaS platform.
                </p>
                <div className="flex justify-between text-sm text-gray-500">
                  <span>Lead Generation</span>
                  <span>B2B Marketing</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Results Section */}
      <section className="py-20 bg-blue-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Proven Results Across Industries
          </h2>
          <p className="text-xl text-blue-100 mb-12 max-w-3xl mx-auto">
            Our data-driven approach consistently delivers measurable growth for businesses of all sizes.
          </p>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">250+</div>
              <div className="text-blue-200">Successful Projects</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">150%</div>
              <div className="text-blue-200">Average ROI Increase</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">98%</div>
              <div className="text-blue-200">Client Satisfaction</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">25+</div>
              <div className="text-blue-200">Industries Served</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Be Our Next Success Story?
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Let&apos;s discuss how we can create a customized marketing strategy that delivers exceptional results for your business.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button href="/contact" variant="primary" size="lg">
              Start Your Project
            </Button>
            <Button href="/services" variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-gray-900">
              View Our Services
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
